// src/pages/GalleryPage.js
import React, { useEffect, useRef, useState } from 'react'; // useStateをインポートに追加

// 画像のインポートを整理
import img2860 from '../assets/images/IMG_2860.jpg';
import img3006 from '../assets/images/IMG_3006_.jpg';
import img4517 from '../assets/images/IMG_4517.jpg';
import img4652 from '../assets/images/IMG_4652.jpg';
import img2626 from '../assets/images/IMG_2626.jpg';
import img4821 from '../assets/images/IMG_4821.jpg';
import img1000021689 from '../assets/images/1000021689.jpg';
import img5303 from '../assets/images/IMG_5303.jpg'; // 新しく追加された画像
import img0480 from '../assets/images/IMG_0480.jpg'; // 新しく追加された画像

import img6705 from '../assets/images/IMG_6705.jpg';
import img6218 from '../assets/images/IMG_6218.jpg';
import img7206 from '../assets/images/IMG_7206.jpg';
import img7387 from '../assets/images/IMG_7387.jpg';
import img7720 from '../assets/images/IMG_7720.jpg';
import img8072 from '../assets/images/IMG_8072.jpg';
import img8101 from '../assets/images/IMG_8101.jpg';
import img8114 from '../assets/images/IMG_8114.jpg';
import img8193 from '../assets/images/IMG_8193.jpg';

import {
  Globe // Globeアイコンをインポート
} from 'lucide-react';


const nordColors = {
  polarNight1: '#3B4252',
  polarNight2: '#434C5E',
  polarNight3: '#4C566A',
  snowStorm0: '#D8DEE9',
  snowStorm1: '#E5E9F0',
  snowStorm2: '#ECEFF4',
  frost1: '#88C0D0',
  frost2: '#81A1C1',
};

// Helper component for section titles with icons (ExperiencePage.jsからコピー)
function SectionTitle({ icon: IconComponent, title, iconColor, titleColor }) {
  return (
    <div className="flex items-center mb-4">
      <IconComponent className="w-7 h-7 md:w-8 md:h-8 mr-3 flex-shrink-0" style={{ color: iconColor }} />
      <h2 className="text-3xl font-semibold" style={{ color: titleColor }}>
        {title}
      </h2>
    </div>
  );
}

// Earth panorama images
const earthPanoramas = [
  {
    id: 1, // idを元の順序で振り直し
    src: img8193,
    alt: 'White Sands National Park',
    location: 'White Sands National Park, New Mexico, USA',
    time: 'November, 2025',
    description: 'A panoramic view of the vast white gypsum sand dunes of White Sands National Park under a clear blue sky.'
  },
  {
    id: 2, // idを元の順序で振り直し
    src: img8114,
    alt: 'Monument Valley',
    location: 'Monument Valley Navajo Tribal Park, Utah & Arizona, USA',
    time: 'November, 2025',
    description: 'A panoramic view of the iconic sandstone buttes of Monument Valley, bathed in the warm glow of the setting sun.'
  },
  {
    id: 3, // idを元の順序で振り直し
    src: img8101,
    alt: 'Canyonlands National Park',
    location: 'Canyonlands National Park, Utah, USA',
    time: 'November, 2025',
    description: 'A panoramic view of the Canyonlands National Park showcasing its dramatic desert landscape and unique rock formations.'
  },
  {
    id: 4, // idを元の順序で振り直し
    src: img8072,
    alt: 'Arches National Park',
    location: 'Arches National Park, Utah, USA',
    time: 'November, 2025',
    description: 'A panoramic view of the natural sandstone arches and rock formations in Arches National Park.'
  },
  {
    id: 5, // idを元の順序で振り直し
    src: img7720,
    alt: 'Craters of the Moon National Monument & Preserve',
    location: 'Craters of the Moon National Monument & Preserve, Idaho, USA',
    time: 'October, 2025',
    description: 'A panoramic view of the unique volcanic landscape of Craters of the Moon National Monument & Preserve.'
  },
  {
    id: 6, // idを元の順序で振り直し
    src: img7387,
    alt: 'Yosemite National Park',
    location: 'Yosemite National Park, California, USA',
    time: 'October, 2025',
    description: 'A panoramic view of the Yosemite National Park showcasing its majestic granite cliffs, waterfalls, and lush forests.'
  },
  {
    id: 7, // idを元の順序で振り直し
    src: img7206,
    alt: 'San Francisco Skyline and Bay',
    location: 'Coit Tower, San Francisco, California, USA',
    time: 'October, 2025',
    description: 'A panoramic view of the San Francisco skyline and bay area, featuring iconic landmarks and vibrant waterfront scenes.'
  },
  {
    id: 8, // idを元の順序で振り直し
    src: img6218,
    alt: 'Cardrona Alpine Resort',
    location: 'Cardrona Alpine Resort, Cardrona, New Zealand',
    time: 'August, 2025',
    description: 'A panoramic view of the Cardrona Alpine Resort, showcasing its scenic mountain landscapes and ski slopes.'
  },
  {
    id: 9, // idを元の順序で振り直し
    src: img6705,
    alt: 'Lake Tahoe Sunset',
    location: 'Monkey Rock, Lake Tahoe, California',
    time: 'June, 2025', // 推測される時期
    description: 'A breathtaking panorama of the clear blue waters of Lake Tahoe from the Monkey Rock Trailhead.'
  },
  {
    id: 10, // idを元の順序で振り直し
    src: img5303,
    alt: 'Chicago Skyline and Lake Michigan',
    location: 'Lakefront Trail, Chicago, Illinois, USA',
    time: 'June, 2024',
    description: 'A panoramic view of the Chicago skyline seen across the vibrant waters of Lake Michigan, framed by green parks and urban walkways.'
  },
  {
    id: 11, // idを元の順序で振り直し
    src: img4821,
    alt: 'Lake Louise, Banff National Park',
    location: 'Lake Louise, Banff National Park, Alberta, Canada',
    time: 'May, 2025', // 推測される時期
    description: 'A panoramic view of the turquoise Lake Louise, surrounded by snow-capped peaks, glaciers, and dense pine forests in Banff National Park.'
  },
  {
    id: 12, // idを元の順序で振り直し
    src: img4652,
    alt: 'Bow Lake, Banff National Park',
    location: 'Bow Lake, Banff National Park, Alberta, Canada',
    time: 'May, 2025', // 推測される時期
    description: 'A panoramic view of the partially frozen Bow Lake, nestled amidst snow-capped mountains in Banff National Park.'
  },
  {
    id: 13, // idを元の順序で振り直し
    src: img4517,
    alt: 'Lake Tahoe, Monkey Rock',
    location: 'Monkey Rock, Lake Tahoe, California',
    time: 'May, 2025', // 推測される時期
    description: 'A breathtaking panorama of the clear blue waters of Lake Tahoe from the Monkey Rock Trailhead.'
  },
  {
    id: 14, // idを元の順序で振り直し
    src: img2860,
    alt: 'Bryce Canyon National Park',
    location: 'Bryce Canyon National Park, Utah, USA',
    time: 'November, 2024', // 推測される時期
    description: 'A stunning winter panorama of Bryce Canyon, featuring snow-dusted hoodoos under a clear blue sky.'
  },  
  {
    id: 15, // idを元の順序で振り直し
    src: img3006,
    alt: 'Antelope Canyon',
    location: 'Antelope Canyon, Arizona, USA',
    time: 'May, 2025', // 推測される時期
    description: 'The iconic slot canyon with its mesmerizing, wave-like rock formations and beams of light.'
  },
  {
    id: 16, // idを元の順序で振り直し
    src: img2626,
    alt: 'Nevada Desert Panorama',
    location: 'Red Rock Canyon Area, Nevada, USA',
    time: 'November, 2024', // 推測される時期
    description: 'A wide view of the Nevada desert landscape, characterized by rugged mountains and sparse vegetation under a bright sun.'
  },
  {
    id: 17, // idを元の順序で振り直し
    src: img1000021689,
    alt: 'Mount Fuji Crater',
    location: 'Mount Fuji, Kengamine Peak, Japan',
    time: 'July, 2024', // 推測される時期 (登山シーズン)
    description: 'A panoramic view of the crater rim of Mount Fuji, Japan\'s iconic highest peak.'
  },
  {
    id: 18, // idを元の順序で振り直し
    src: img0480,
    alt: 'Mount Batur and Lake Batur, Bali',
    location: 'Mount Batur Viewpoint, Kintamani, Bali, Indonesia',
    time: 'June, 2024',
    description: 'A sweeping view of the volcanic Mount Batur and the serene Lake Batur, captured from a popular panoramic lookout surrounded by cafes and tourists.'
  }
];

function GalleryPage() {
  return (
    <section className="bg-polarNight1 bg-opacity-70 p-6 md:p-8 rounded-xl shadow-lg border border-polarNight3">
      <SectionTitle
        icon={Globe}
        title="Earth Panorama Gallery"
        iconColor={nordColors.frost1} // アイコンの色を指定
        titleColor={nordColors.frost2}
      />
      <p className="text-lg leading-relaxed mb-6" style={{ color: nordColors.snowStorm0 }}>
        Explore beautiful panoramas of Earth, showcasing diverse landscapes and atmospheric phenomena captured from space.
      </p>
      <p className="text-sm text-frost1 block md:hidden mb-6">
        * You can scroll horizontally to view the full panorama on mobile.
      </p>
      <div className="grid grid-cols-1 gap-8">
        {earthPanoramas.map(panorama => (
          <PanoramaCard key={panorama.id} panorama={panorama} /> // PanoramaCardコンポーネントを使用
        ))}
      </div>
    </section>
  );
}


// 新しいPanoramaCardコンポーネントを定義
function PanoramaCard({ panorama }) {
  const scrollRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false); // 画像のロード状態を管理するstateを追加

  useEffect(() => {
    // コンポーネントがマウントされたとき、および依存配列が変更されたときに実行
    // imageLoadedがtrueになってから処理を実行することで、画像が完全にロードされたことを保証
    if (scrollRef.current && imageLoaded) {
      const imageElement = scrollRef.current.querySelector('img'); // img要素を取得
      if (imageElement) {
        // 画像の実際の幅とコンテナの表示幅に基づいて中央にスクロール
        const imageWidth = imageElement.scrollWidth; // img要素の幅を取得
        const containerWidth = scrollRef.current.clientWidth; // コンテナの表示幅を取得

        // 画像がコンテナより大きい場合にのみスクロールを適用
        if (imageWidth > containerWidth) {
          scrollRef.current.scrollLeft = (imageWidth - containerWidth) / 2;
        } else {
          // 画像がコンテナに収まる場合は、Flexboxで中央寄せする
          scrollRef.current.style.justifyContent = 'center';
          scrollRef.current.style.display = 'flex';
        }
      }
    }
  }, [imageLoaded, panorama.src]); // imageLoadedとpanorama.srcが変更されたときに再実行

  // 画像がロードされたときに呼び出されるハンドラー
  const handleImageLoad = () => {
    setImageLoaded(true); // 画像のロードが完了したことをマーク
  };

  return (
    <div className="bg-polarNight2 p-5 rounded-lg border border-polarNight3 hover:border-frost0 transition-all duration-200">
      <div
        ref={scrollRef}
        className="overflow-x-auto whitespace-nowrap lg:overflow-x-hidden lg:whitespace-normal scrollbar-hide"
      >
        <img
          src={panorama.src}
          alt={panorama.alt}
          className="h-64 inline-block rounded-md mb-4 object-cover"
          style={{ width: 'auto', maxWidth: 'none' }}
          onLoad={handleImageLoad} // 画像ロード時にhandleImageLoadを実行
        />
      </div>
      <h3 className="text-xl font-semibold mb-2" style={{ color: nordColors.snowStorm2 }}>
        {panorama.location}
      </h3>
      <p className="text-base" style={{ color: nordColors.snowStorm1 }}>
        {panorama.time}
      </p>
      <p className="text-base mt-2" style={{ color: nordColors.snowStorm0 }}>
        {panorama.description}
      </p>
    </div>
  );
}

export default GalleryPage;
